// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"mM-z","upvoteIcon":"nM-z","downvoteIcon":"oM-z","feedbackIcon":"pM-z"};